import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { WhatsAppCTA } from "./WhatsAppCTA";

const LINKS = [
  { to: "/", label: "Home", testId: "nav-link-home" },
  { to: "/chi-siamo", label: "Chi Siamo", testId: "nav-link-chi-siamo" },
  { to: "/membri", label: "Membri", testId: "nav-link-membri" },
  { to: "/eventi", label: "Eventi", testId: "nav-link-eventi" },
  { to: "/adesione", label: "Aderisci", testId: "nav-link-adesione" },
  { to: "/contatti", label: "Contatti", testId: "nav-link-contatti" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header data-testid="main-navbar" className="fixed inset-x-0 top-0 z-50 border-b border-ink bg-bone/95 backdrop-blur-sm">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between gap-4 px-5 md:h-20 md:px-10">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3" aria-label="Torna alla home">
          <img src="/logo.png" alt="Logo Movimento Civico Progetto Città" className="h-10 w-auto md:h-12" />
          <span className="font-oswald text-sm font-semibold uppercase leading-[1.05] tracking-tight md:text-base">
            Progetto
            <br />
            <span className="text-orange">Città</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Navigazione principale">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `font-oswald text-sm uppercase tracking-[0.18em] transition-colors duration-300 hover:text-orange ${
                  isActive ? "text-orange" : "text-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden sm:block">
            <WhatsAppCTA testId="nav-whatsapp-button" />
          </div>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Chiudi menu" : "Apri menu"}
            aria-expanded={open}
            className="flex h-11 w-11 items-center justify-center border border-ink lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="mobile-menu" className="border-t border-ink bg-bone lg:hidden" aria-label="Menu mobile">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-${l.testId}`}
              className={({ isActive }) =>
                `block border-b border-ink/20 px-5 py-4 font-oswald text-2xl font-semibold uppercase tracking-tight ${
                  isActive ? "text-orange" : "text-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <div className="px-5 py-5">
            <WhatsAppCTA testId="mobile-whatsapp-button" />
          </div>
        </nav>
      )}
    </header>
  );
};
